export default __webpack_public_path__ + "static/media/rumptz-html.2ccc38aa.JPG";